import Axios from 'axios'
import config from 'config'
import { isIos } from './index'

const { baseApiUrl } = config
// 创建一个 Axios 实例
export const service = Axios.create({
  baseURL: baseApiUrl,
  timeout: 10 * 1000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    let headers = {
      'TM-UserAgent-appChannel': 'web',
      'TM-UserAgent-appUserAuthToken': Math.random().toString(32).slice(2, 10),
      'TM-UserAgent-deviceOS': isIos() ? 'ios' : 'android',
      'TM-UserAgent-appIdentityVersion': 1
    }
    config.headers = Object.assign(headers, config.headers)
    return config
  },
  error => {
    // 发送失败
    Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.data !== undefined) {
      return response.data
    } else {
      return response
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
